/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PutAuditLogRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {PutAuditLogResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const putAuditLog = (request:PutAuditLogRequest, options?: CashRequestOptions) => post<PutAuditLogRequest, PutAuditLogResponse>("/2.0/cash/put-audit-log", request, {...options, rejectOnError: true })